import React from 'react';


class Footer extends React.Component {

    render() {
        return (
            <div id="footer" role="contentinfo">
                <div style={{ textAlign: 'initial' }}>
                    <a href="https://ufl.edu/">
                        <img src="/images/uf_logo.png" alt="UF" />
                    </a>
                </div>
                <hr color="white" />

                <ul>
                    <li>
                        <a href="mailto:Appteam@ifas.ufl.edu?subject=GI-BMP Website Feedback">Site Feedback</a>
                        <span>|</span>
                    </li>
                    <li >&copy;&nbsp;2026
                        <span>|</span>
                    </li>
                    <li >
                        <a href="https://ufl.edu" rel="noopener noreferrer external" target="_blank">University of Florida,</a>&nbsp;<a href="https://ifas.ufl.edu/" rel="noopener noreferrer external" target="_blank">Institute of Food and Agricultural Sciences</a>
                        <span >|</span>
                    </li>
                    <li >P.O. Box 110810 Gainesville, FL 32611
                        <span >|</span>
                    </li>
                    <li>(352) 273-4517
                        <span >|</span>
                    </li>
                    <li >Analytics (<a href="https://policies.google.com/privacy?hl=en&gl=us" rel="noopener noreferrer external" target="_blank">Google Privacy Policy</a>)
                        <span >|</span>
                    </li>
                    <li>Policies:&nbsp;<a href="https://www.ufl.edu/disability/" rel="noopener noreferrer external" target="_blank">Disability Services</a>
                        <span >|</span>
                    </li>
                    <li>
                        <a href="https://privacy.ufl.edu/policies/onlineinternet-privacy-policy-/" rel="noopener noreferrer external" target="_blank">UF Privacy</a>
                    </li>
                   
                    <br />
                </ul>
            </div>
        );
    }
}

export default Footer;